import { render, staticRenderFns } from "./FundingDetailsSidebar.vue?vue&type=template&id=6a20f656&scoped=true&"
import script from "./FundingDetailsSidebar.vue?vue&type=script&lang=js&"
export * from "./FundingDetailsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./FundingDetailsSidebar.vue?vue&type=style&index=0&id=6a20f656&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a20f656",
  null
  
)

export default component.exports